import React from 'react';
import './cover.css'

function Cover({type,imagee}) {
    return (
        <div draggable className="cover">
            <p className="memeType">
            {type}
            </p>
            <img draggable="false" src={imagee}></img>
           
           
        </div>
    )
}

export default Cover
